<template>
    <div>
        <div ref="popup" class="blur">
            <div class="pop">
                <img @click="hideMsg" src="../assets/images/cross.svg" class="close">
                <div class="message-wrapper">
                    <div class="success-img">
                        <img src="../assets/images/thumbs_up.svg">
                    </div>
                    <div class="success-message">
                    {{ msg }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    export default {
        name: 'SuccessMsgPanel',
        components: {
        },
        props: {
            msg: {
                type: String,
                required: true,
                default: ''
            },
            show: {
                type: Boolean,
                required: true,
                default: false
            },
        },
        // data() {
        //     return {
        //     },
        // },
        watch: {
            show(newShow, oldShow) {
                this.showMsg();
            },
            msg(newMsg, oldMsg) {
                this.showMsg();
            }
        },
        methods: {
            showMsg(){
                if(this.show && this.msg != ""){
                    $(this.$refs.popup).show(200);
                }
                else{
                    $(this.$refs.popup).hide(200);
                }
            },
            hideMsg(){
                this.$emit('input');
            }
        },
        mounted(){
            $(this.$refs.popup).css("display", "none");
        }
    }
    </script>
    <style lang="scss" scoped>
    .blur {
        width: 100%;
        left: 50%;
        background-color: #ffffff87;
        backdrop-filter: blur(7px);
        height: 100%;
        top: 50%;
        z-index: 10000;
        position: fixed;
        transform: translate(-50%,-50%);
        color: #ffffff7c;

        .pop {
            position: absolute;
            top: 50%;
            color: black;
            border-radius: 25px;
            width: auto;
            box-shadow: 7px 7px 15px #00000029;
            background-color: #e4f4f9;
            left: 50%;
            transform: translate(-50%,-50%);
            height: 370px;
            .close{
                width: 21px !important;
                position: absolute;
                right: 13px !important;
                top: 13px;
                padding: 5px !important;
                cursor: pointer !important;
                left: unset !important;
            }
            .message-wrapper{
                width: 480px;
                //height: 370px;
                text-align: center;
                margin-top: 90px;
                .success-message{
                    color: #3A87A3;
                    font-weight: bold;
                    margin-top: 20px;
                }
            }
        }
    }
    </style>